export default {
  namespaced: true,
  inventory_project_catalog: {
    menu: "Catálogo de Projetos",
    title: "Projeto",
    project_id: "ID do Projeto",
    test: "ID do Projeto",
    name: "Nome",
    created_at: "Criado em",
    updated_at: "Atualizado em",
  },
};
